/*=========================================================================================
 File Name: sidebarItems.js
 Description: Sidebar Items list. Add / Remove menu items from here.
 Strucutre:
 url     => router path
 name    => name to display in sidebar
 slug    => router path name
 icon    => Feather Icon component/icon name
 tag     => text to display on badge
 tagColor  => class to apply on badge element
 i18n    => Internationalization
 submenu   => submenu of current item (current item will become dropdown )
 NOTE: Submenu don't have any icon(you can add icon if u want to display)
 isDisabled  => disable sidebar item/group
 ----------------------------------------------------------------------------------------
 Item Name: Vuesax Admin - VueJS Dashboard Admin Template
 Author: Pixinvent
 Author URL: http://www.themeforest.net/user/pixinvent
 ==========================================================================================*/

import $store from "@/store/store";

export default [
  {
    header:    "PR",
    i18n:      "UIElements",
    user:      "isEmployee",
    abilities: "pr",
  },
  {
    url:       "/uc/news",
    name:      "Новости",
    slug:      "news",
    icon:      "Edit2Icon",
    user:      "isEmployee",
    abilities: "pr.news",
  },
  // {
  //   url:       "/uc/posters",
  //   name:      "Объявления",
  //   slug:      "posters",
  //   icon:      "ImageIcon",
  //   user:      "isEmployee",
  //   abilities: "pr.posters",
  // },
  {
    header:    "Диспетчерская",
    i18n:      "UIElements",
    user:      "isEmployee",
    abilities: "issues",
  },
  {
    // url:       "/uc/issues/new/view/all",
    url:       "/uc/issues",
    name:      "Заявки",
    slug:      "uc_issues",
    icon:      "InboxIcon",
    user:      "isEmployee",
    abilities: "issues",
    tagColor:  'warning',
    get tag() {
      return $store.getters['common/tasks/unreadMessagesTotal'];
    },
    // submenuOpen: true,
    // submenu:     [
    //   {
    //     // url:       {
    //     //   name:  'uc_issues_new',
    //     //   query: { filters: '[["status_id","equals","1|2"]]', orderBy: ['created_at', 'Asc'] },
    //     // },
    //     url:       { name: 'uc_issues_new', query: { status_id: [1, 2], sort: 'created_at', order: 'asc' } },
    //     name:      'Новые',
    //     slug:      "uc_issues_new",
    //     user:      "isEmployee",
    //     abilities: "issues",
    //     icon:      "CircleIcon",
    //     iconClass: "vs-sidebar-icon-new",
    //   },
    //   {
    //     get url() {
    //       const id = $store.getters['appUser/id'];
    //       return {
    //         name:  'uc_issues_assigned',
    //         query: { status_id: [3], performer_id: [id], sort: 'updated_at', order: 'desc' },
    //       };
    //     },
    //     name:      'Назначено',
    //     slug:      "uc_issues_assigned",
    //     user:      "isEmployee",
    //     abilities: "issues",
    //     icon:      "CircleIcon",
    //     iconClass: "vs-sidebar-icon-assigned",
    //   },
    //  {
    //     get url() {
    //       const id = $store.getters['appUser/id'];
    //       return {
    //         name:  'uc_issues_progress',
    //         query: { status_id: [4], performer_id: [id], sort: 'updated_at', order: 'desc' },
    //       };
    //     },
    //     name:      'В работе',
    //     slug:      "uc_issues_progress",
    //     user:      "isEmployee",
    //     abilities: "issues",
    //     icon:      "CircleIcon",
    //     iconClass: "vs-sidebar-icon-work",
    //   },
    //   {
    //     url:       { name: 'uc_issues_closed', query: { status_id: [5, 6], sort: 'updated_at', order: 'desc' } },
    //     // url:       { name: 'uc_issues_closed' },
    //     name:      'Завершенные',
    //     slug:      "uc_issues_closed",
    //     user:      "isEmployee",
    //     abilities: "issues",
    //     icon:      "CircleIcon",
    //     iconClass: "vs-sidebar-icon-done",
    //   },
    // ],
  },
  // {
  //   url:       "/uc/issues/new/commercial/view/all",
  //   name:      "Коммерческие услуги",
  //   slug:      "uc_issues",
  //   icon:      "PercentIcon",
  //   user:      "isEmployee",
  //   abilities: "issues",
  // },
  {
    url:       "/uc/issues/analytics/houses",
    name:      "Аналитика",
    slug:      "uc_issues_analytics",
    icon:      "PieChartIcon",
    user:      "isEmployee",
    abilities: "issues",
  },
  // {
  //   url: "/uc/tasks",
  //   name: "Задачи",
  //   slug: "uc_tasks",
  //   icon: "TrelloIcon",
  //   user: "isEmployee",
  //   abilities: "issues.tasks",
  // },
  {
    header:    "Работа с должниками",
    i18n:      "UIElements",
    user:      "isEmployee",
    abilities: "debtors",
  },
  {
    url:       "/uc/debtors/sms",
    name:      "Отправка СМС",
    slug:      "uc_debtors_sms",
    icon:      "SmartphoneIcon",
    user:      "isEmployee",
    abilities: "debtors.sms",
  },
  {
    url:       "/uc/debtors/email",
    name:      "Отправка Email",
    slug:      "uc_debtors_email",
    icon:      "MailIcon",
    user:      "isEmployee",
    abilities: "debtors.email",
  },
  {
    url:       "/uc/notifies",
    name:      "Уведомления",
    slug:      "uc_notifies",
    icon:      "ClipboardIcon",
    user:      "isEmployee",
    abilities: "debtors.notify",
  },

  {
    header:    "Льготы",
    i18n:      "UIElements",
    user:      "isEmployee",
    abilities: "rp",
    mcsIds:    [13],
  },
  {
    url:       "/uc/b/privileges",
    name:      "Выгрузка начислений",
    slug:      "import",
    icon:      "PercentIcon",
    user:      "isEmployee",
    abilities: "rp.charges",
    mcsIds:    [13],
  },
  {
    header:    "Льготы",
    i18n:      "UIElements",
    user:      "isEmployee",
    abilities: "rp",
    mcsIds:    [15],
  },
  {
    url:       "/uc/b/gcjs",
    name:      "Заполнение ГЦЖС",
    slug:      "import",
    icon:      "PercentIcon",
    user:      "isEmployee",
    abilities: "rp.charges",
    mcsIds:    [15],
  },

  {
    header:    "Расчетная программа",
    i18n:      "UIElements",
    user:      "isEmployee",
    abilities: "rp",
  },
  {
    url:       "/uc/b/",
    name:      "Общая информация",
    slug:      "cmninfo",
    icon:      "HomeIcon",
    user:      "isEmployee",
    abilities: "rp.main",
  },
  {
    url:       "/uc/b/accounts",
    name:      "Список счетов",
    slug:      "accounts",
    icon:      "ListIcon",
    user:      "isEmployee",
    abilities: "rp.main",
  },
  {
    url:       "/uc/b/financial-analytics",
    name:      "Финансовая аналитика",
    slug:      "financial_analytics",
    icon:      "TrendingUpIcon",
    user:      "isEmployee",
    abilities: "rp.fin_analysis",
  },
  {
    url:       "/uc/b/devices",
    name:      "Приборы учета и показания",
    slug:      "metering",
    icon:      "MonitorIcon",
    user:      "isEmployee",
    abilities: "rp.devices",
  },
  {
    url:       "/uc/b/tariffs",
    name:      "Тарифы",
    slug:      "tariffs_new",
    icon:      "RubleIcon",
    user:      "isEmployee",
    abilities: "rp.tariffs",
    submenu:   [{
      name:      'Архив',
      slug:      "tariffs_archive0",
      url:       '/uc/b/tariffs/archive',
      user:      "isEmployee",
      abilities: "rp.tariffs",
    }],
  },
  {
    url:       "/uc/b/accruals",
    name:      "Начисления",
    slug:      "accruals",
    icon:      "CreditCardIcon",
    user:      "isEmployee",
    abilities: "rp.charges",
  },
  {
    url:       "/uc/b/recalculations",
    name:      "Перерасчеты",
    slug:      "recalculation",
    icon:      "RotateCcwIcon",
    user:      "isEmployee",
    abilities: "rp.recalculation",
  },
  {
    url:       "/uc/b/fines-recalculations",
    name:      "Перерасчеты пеней",
    slug:      "fines-recalculation",
    icon:      "GitPullRequestIcon",
    user:      "isEmployee",
    // abilities: "support",
    abilities: "rp.recalculation",
  },
  {
    url:       "/uc/b/invoices",
    name:      "Квитанции",
    slug:      "invoices",
    icon:      "TrelloIcon",
    user:      "isEmployee",
    abilities: "rp.kv",
  },
  {
    url:       "/uc/b/payments",
    name:      "Платежи",
    slug:      "payments",
    icon:      "LayersIcon",
    user:      "isEmployee",
    abilities: "rp.invoices",
  },
  {
    url:       "/uc/b/refunds",
    name:      "Возвраты",
    slug:      "payments",
    icon:      "LayersIcon",
    user:      "isEmployee",
    abilities: "rp.refunds",
  },
  {
    url:       "/uc/b/reports",
    name:      "Отчеты",
    slug:      "reports_",
    icon:      "FileIcon",
    user:      "isEmployee",
    abilities: "rp.reports",
  },
  {
    url:           "/uc/b/import",
    name:          "Импорт",
    slug:          "import",
    icon:          "UploadIcon",
    user:          "isEmployee",
    abilities:     ["rp.devices", "rp.apartments_import", "rp.invoices"],
    abilitiesRule: 'write',
  },
  {
    url:       "/uc/b/regulations",
    name:      "Нормативы",
    slug:      "regulations",
    icon:      "BookIcon",
    user:      "isEmployee",
    abilities: "rp.tariffs",
  },
  // {
  //   url: "/uc/b/unidentified-payments",
  //   name: "Неопознанные платежи",
  //   slug: "unidentified-payments",
  //   icon: "FileTextIcon",
  //   user: "isEmployee",
  // },
  {
    url:       "/uc/b/invoice",
    name:      "Квитанция",
    slug:      "invoice",
    icon:      "TrelloIcon",
    user:      "isEmployee",
    abilities: "rp.kv",
  },
  {
    url:       "/uc/b/settings",
    name:      "Настройки дома",
    slug:      "house-settings",
    icon:      "SettingsIcon",
    user:      "isEmployee",
    abilities: "rp.settings",
  },
  {
    url:       "/uc/b/emails",
    name:      "Email рассылки",
    slug:      "emails-campaigns",
    icon:      "MailIcon",
    user:      "isEmployee",
    abilities: "rp.emails",
  },
  {
    url:       "/uc/b/acts",
    name:      "Акты",
    slug:      "employee_acts",
    icon:      "FilesIcon",
    user:      "isEmployee",
    abilities: "rp.acts",
  },
  {
    url:       "/uc/b/gis",
    name:      "ГИС ЖКХ",
    slug:      "uc-b-gis",
    icon:      "GisIcon",
    user:      "isEmployee",
    abilities: "rp.gis",
  },
  {
    url:       "/uc/consistency-reports",
    name:      "Проверка данных",
    slug:      "uc-consistency-reports",
    icon:      "CodesandboxIcon",
    user:      "isEmployee",
    abilities: "rp.debug",
  },
  {
    url:           "/uc/add-devices-values",
    name:          "Подача показаний",
    slug:          "add-devices-values",
    icon:          "MonitorIcon",
    user:          "isEmployee",
    abilities:     "rp.worker.add_values",
    abilitiesRule: 'write',
  },
  {
    url:  "/uc/check-metering",
    name: "Заполнение показаний",
    slug: "check-metering",
    icon: "TabletIcon",
    user: "isEmployee",
  },

  // Клиент
  {
    url:  "/",
    name: "Главная",
    slug: "home",
    icon: "HomeIcon",
    user: "isClient",
  },
  {
    url:      "/issues",
    name:     "Заявки",
    slug:     "client_issues",
    icon:     "CheckSquareIcon",
    user:     "isClient",
    tag:      0,
    tagColor: 'warning',
  },
  {
    url:  "/metering",
    name: "Приборы учета",
    slug: "metering",
    icon: "MonitorIcon",
    user: "isClient",
  },
  {
    url:  "/invoices",
    name: "Квитанции",
    slug: "invoices",
    icon: "LayersIcon",
    user: "isClient",
  },
  {
    url:  "/payments",
    name: "Платежи",
    slug: "payments",
    icon: "RubleIcon",
    user: "isClient",
  },
  {
    url:  "/my-own",
    name: "Собственность",
    slug: "myOwn",
    icon: "SettingsIcon",
    user: "isClient",
  },
  {
    url:  "/profile",
    name: 'Профиль',
    slug: "profile",
    icon: "UserIcon",
    user: "isClient",
  },
  // Superadministrator
  {
    header: "Администратор",
    i18n:   "UIElements",
    user:   "isAdmin",
  },
  {
    url:  "/admin/news",
    name: "Новости",
    slug: "news",
    icon: "Edit2Icon",
    user: "isAdmin",
  },
  {
    url:  "/admin/admins",
    name: "Суперадминистраторы",
    slug: "superadmins",
    icon: "CpuIcon",
    user: "isAdmin",
  },
  {
    url:  "/admin/companies",
    name: "Управляющие компании",
    slug: "management_companies",
    icon: "ChromeIcon",
    user: "isAdmin",
  },
  {
    url:  "/admin/houses",
    name: 'Дома',
    slug: "houses",
    icon: "HomeIcon",
    user: "isAdmin",
  },
  {
    url:  "/admin/users",
    name: 'Администраторы УК',
    slug: "profile",
    icon: "UserIcon",
    user: "isAdmin",
  },
  {
    url:  "/admin/settings",
    name: 'Настройки',
    slug: "settings",
    icon: "AnchorIcon",
    user: "isAdmin",
  },
  {
    url:  "/admin/print-checks",
    name: 'Печать чеков',
    slug: "admin_print_checks",
    icon: "PrinterIcon",
    user: "isAdmin",
  },
  {
    url:  "/admin/test-pay",
    name: 'Тестовая оплата',
    slug: "admin_print_checks",
    icon: "RubleIcon",
    user: "isAdmin",
  },
  {
    url:  "/admin/users-control",
    name: 'Управление пользователями',
    slug: "admin_login_user",
    icon: "UsersIcon",
    user: "isAdmin",
  },
  {
    url:  "/admin/permission-entities",
    name: 'Управление сущностями прав',
    slug: "admin_permission_entities",
    icon: "BookOpenIcon",
    user: "isAdmin",
  },
  {
    url:  "/admin/house-import/devices",
    name: 'Импорт дома (устройства)',
    slug: "admin_house-import_devices",
    icon: "MonitorIcon",
    user: "isAdmin",
  },
  {
    url:  "/admin/reports-settings",
    name: 'Отчеты (настройки)',
    slug: "admin_reports_settings",
    icon: "FileIcon",
    user: "isAdmin",
  },
  {
    header: "Управляющая компания",
    i18n:   "UIElements",
    user:   "isMcAdmin",
  },
  {
    url:  `/${process.env.VUE_APP_MCADMIN_BASE_URL}/company-houses`,
    name: 'Управление домами',
    slug: "admin_permissions_control",
    icon: "HomeIcon",
    user: "isMcAdmin",
  },
  {
    url:  `/${process.env.VUE_APP_MCADMIN_BASE_URL}/company-structure`,
    name: 'Структура компании',
    slug: "admin_permissions_control",
    icon: "UsersIcon",
    user: "isMcAdmin",
  },
  {
    url:  `/${process.env.VUE_APP_MCADMIN_BASE_URL}/permissions-control`,
    name: 'Права пользователей',
    slug: "admin_permissions_control",
    icon: "UnlockIcon",
    user: "isMcAdmin",
  },

];
